import { FadeIn } from "../ui/fade-in"
import { Shield, Users } from "lucide-react"

export function AboutSection() {
  return (
      <section id="about" className="py-20 bg-black relative overflow-hidden">
        {/* Background gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-black to-black/90"></div>

        {/* Red accent */}
        <div className="absolute left-0 top-1/4 h-32 w-1 bg-red-600"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <FadeIn direction="right">
              <div className="relative">
                <div className="absolute -top-6 -left-6 w-24 h-24 bg-red-600/20 rounded-full blur-xl"></div>
                <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-red-600/10 rounded-full blur-xl"></div>

                <div className="relative bg-black/40 backdrop-blur-sm border border-white/10 rounded-xl p-6 md:p-8">
                  <Shield className="w-12 h-12 text-red-600 mb-4" />
                  <h2 className="text-3xl font-bold mb-4">À propos de S&M</h2>
                  <p className="text-gray-300 mb-6">
                    S&M est un fournisseur de services managés en cybersécurité (MSP), basé au Maroc et dédié à l’accompagnement des intégrateurs de solutions de sécurité sur le continent africain. Nous intervenons en support technique stratégique, dès la phase d’avant-vente jusqu’au déploiement et à la maintenance des solutions.
                  </p>
                  <div className="flex flex-row gap-6 items-center justify-center text-gray-400">
                    <Users className="w-32 h-32 md:w-16 md:h-16 text-red-600" />
                    <span>Grâce à une équipe de consultants certifiés sur les solutions des éditeurs leaders du marché, nous renforçons les capacités des intégrateurs pour garantir le succès des projets de cybersécurité de bout en bout.</span>
                  </div>
                </div>
              </div>
            </FadeIn>

            <FadeIn direction="left">
              <div className="space-y-6">
                <div className="bg-black/40 backdrop-blur-sm border border-white/10 rounded-xl p-6">
                  <h3 className="text-xl font-semibold mb-2">Notre Mission</h3>
                  <p className="text-gray-400">
                    Faciliter l’intégration des solutions de cybersécurité en Afrique en offrant aux intégrateurs un soutien complet, technique et stratégique, tout au long du cycle de vie de leurs projets.
                  </p>
                </div>

                <div className="bg-black/40 backdrop-blur-sm border border-white/10 rounded-xl p-6">
                  <h3 className="text-xl font-semibold mb-2">Notre Approche</h3>
                  <p className="text-gray-400 mb-2">
                    Nous mettons à disposition des compétences expertes certifiées dans des domaines clés de la cybersécurité pour:
                  </p>
                  <ul className="text-gray-400 space-y-2">
                    <li>• Répondre aux appels d’offres techniques</li>
                    <li>• Réaliser des POC (Proof of Concept)</li>
                    <li>• Déployer des solutions complexes</li>
                    <li>• Fournir un support post-projet</li>
                  </ul>
                </div>

                <div className="bg-black/40 backdrop-blur-sm border border-white/10 rounded-xl p-6">
                  <h3 className="text-xl font-semibold mb-2">Nos Valeurs</h3>
                  <ul className="text-gray-400 space-y-2">
                    <li>• Soutien actif aux intégrateurs</li>
                    <li>• Excellence technique et certifications</li>
                    <li>• Adaptabilité aux réalités du marché africain</li>
                    <li>• Engagement dans la durée</li>
                  </ul>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </section>
  )
}
